import React from 'react'
import Dropdown from 'core-system/Dropdown'
import styled from 'styled-components'
import Text from 'core-system/Text/Text'
import palette from 'core-system/Themes/palette'
import launchProgramsWordings from 'features/Programs/Shared/wordings.json'
import { useDispatch, useSelector } from 'react-redux'
import { launchProgramsActions } from '../launchProgramActions'
import { AppState } from 'redux/config/store'
import { SelectItemProps } from 'core-system/Dropdown'
import { CurrencyType } from '../../Shared/types'

const PageItem = styled.div`
  margin-bottom: 2.5rem;
`

const TitleContainer = styled(Text)`
  margin-bottom: 1rem;
  color: ${palette.text.primary};
`

const CurrencySelector = () => {
  const dispatch = useDispatch()
  const { currency } = useSelector((state: AppState) => state.launchPrograms)

  const currencyOptions: SelectItemProps[] = [
    { id: 'USD', text: 'USD' },
    { id: 'CAD', text: 'CAD' },
    { id: 'EUR', text: 'EUR' },
    { id: 'PLN', text: 'PLN' },
  ]

  const handleCurrencyChange = (item: SelectItemProps) => {
    dispatch(launchProgramsActions.changeCurrency(item.id as CurrencyType))
  }

  return (
    <PageItem>
      <TitleContainer variant='h5'>
        {launchProgramsWordings.selectCurrencyTitle}
      </TitleContainer>
      <Dropdown
        active={currency}
        items={currencyOptions}
        itemCallback={handleCurrencyChange}
        width='100%'
      />
    </PageItem>
  )
}

export default CurrencySelector
